import some from 'lodash/some';
import { NULL_ANSWER__NOT_APPLICABLE } from '../constants';

// TECH-3934, decision D3: only numeric answers count as answered, so a "Not
// applicable" choice that carries a number is counted as an answer and adds to
// the score. The author must remove it; Form Builder uses this to warn.

const NOT_APPLICABLE_TEXT = /^\s*(n\s*\/?\s*a|not\s+applicable)\s*$/i;

const isNotApplicableChoice = (choice) =>
  choice.value === NULL_ANSWER__NOT_APPLICABLE ||
  NOT_APPLICABLE_TEXT.test(String(choice.value)) ||
  NOT_APPLICABLE_TEXT.test(String(choice.label || ''));

const isNumberedNotApplicableChoice = (question, choice) =>
  isNotApplicableChoice(choice) &&
  !Number.isNaN(question.toNumericValue(choice.value));

/**
 * Return the questions that have a "Not applicable" choice with a numeric value.
 * @param {Array<Question>} questions
 * @returns {Array<Question>}
 */
export const getNumberedNotApplicableQuestions = (questions) =>
  (questions || []).filter((question) =>
    some(question.choices, (choice) =>
      isNumberedNotApplicableChoice(question, choice),
    ),
  );
